module.exports = __webpack_public_path__ + "img/ubiquity.997dcd33.webp";